import { dataSparklesSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSparklesSolid = /*#__PURE__*/createIcon(dataSparklesSolid)
export default IconSparklesSolid
